import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { CategoryService } from '../services/category.service';
import { CreateCategoryComponent } from './create-category/create-category.component';
import { EditCategoryComponent } from './edit-category/edit-category.component';
import { ImportCategoryComponent } from './import-category/import-category.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css'],
})
export class CategoryComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: CreateCategoryComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditCategoryComponent;
  @ViewChild('pImport', { static: false }) pImport: ImportCategoryComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: CategoryService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'code',
        header: 'Mã dịch vụ',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'name',
        header: 'Tên dịch vụ',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      search: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };

    this._service
      .getListCategory(model)
      .then((res) => {
        if (res) {
          this.dataSource = res.data;
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editCategory(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
    this.pEdit.showPopup(model);
  }
  deleteCategory(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động dịch vụ này')
        .then((res) => {
          if (res) {
            // this._service.delete(item.identifier).then(
            //   () => {
            //     this._notifierService.showDeleteDataSuccess();
            //     this.getData();
            //   },
            //   () => {
            //     this._notifierService.showDeleteDataError();
            //   }
            // );
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }
  onAdd() {
    this.pCreate.showPopup();
  }

  onImport() {
    this.pImport.showPopup();
  }
  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
